import {
    FETCH_ROOM_LIST_REQUEST,
      FETCH_ROOM_LIST_SUCCESS,
      FETCH_ROOM_LIST_FAILURE,
    } from "./FetchRoomListTypes";
    import api from "../../utils/Api";
    
    export const fetchRoomListRequest = () => {
      return {
        type: FETCH_ROOM_LIST_REQUEST,
      };
    };
    
    export const fetchRoomListSuccess = (roomDropDownList) => {
      return {
        type: FETCH_ROOM_LIST_SUCCESS,
        payload: roomDropDownList,
      };
    };
    
    export const fetchRoomListFailure = (error) => {
      return {
        type: FETCH_ROOM_LIST_FAILURE,
        payload: error,
      };
    };
    
    export const fetchRoomDropDownListing = () => {
      
      const headers = {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      };
      let url = "room/dropdown/fetch";
    
      
      return async (dispatch) => {
        dispatch(fetchRoomListRequest);
        try {
          const response = await api.get(url,
            {
              headers: headers,
            }
          );
          const roomDropDownList = response.data.data;
          dispatch(fetchRoomListSuccess(roomDropDownList));
        } catch (error) {
          console.log("Redux error - ", error.response);
          const errorMsg = error.message;
          dispatch(fetchRoomListFailure(errorMsg));
        }
      };
    };
    